import React from 'react';
import { FaPhone  } from 'react-icons/fa'; // Importer les icônes nécessaires

// ButtonEdit avec une icône d'édition
const ButtonTel = ({ onClick, className = '', hoverLabel = 'Téléphoner'  }) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel} 
      className={`w-8 h-8 bg-green-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-green-700 flex items-center justify-center ${className}`}
    >
      <FaPhone  className='text-[12px]'/>
    </button>
  );
};


export default ButtonTel;
